export default __webpack_public_path__ + "static/media/listItem2.ade4c848.svg";